import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import { getField, updateField } from "vuex-map-fields";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

const vuexPersist = new VuexPersistence({
  // Application initial key for store data on localStorage could be based on route / pathaname
  key: `data-sec-portal`,
  storage: window.localStorage,
  modules: ["auth", "common", "assets", "theme", "vue-scrollto/nuxt"],
});

export default new Vuex.Store({
  strict: true,
  state: {
    packageVersion: process.env.PACKAGE_VERSION || "0",
  },
  getters: {
    appVersion: (state) => {
      return state.packageVersion;
    },
    getField,
  },
  mutations: {
    updateField,
  },
  modules: modules,
  plugins: [vuexPersist.plugin],
});
